import classNames from 'classnames'
import { CSSProperties } from 'react'
import { RenderElementProps } from 'slate-react'

import { TTableCellElement } from 'core-components/library/richTextEditor/interface/custom-types'

import styles from './TableCell.module.scss'

interface IProps {
  style: CSSProperties
  className: string
  dataKey: string
}

export const TableCell = (props: RenderElementProps & IProps) => {
  return (
    <td
      style={{
        ...props.style,
        ...{ backgroundColor: `var(--selected-cell-color, ${props.element['backgroundColor']})` },
        ...{ borderColor: props.element['borderColor'] },
      }}
      className={classNames(
        props.className,
        styles.tCell,
        (props.element as TTableCellElement).selectedCell ? styles.selectedCell : '',
        {
          [styles.verticalAlignTop]: (props.element as TTableCellElement).verticalAlign === 'top',
          [styles.verticalAlignBottom]:
            (props.element as TTableCellElement).verticalAlign === 'bottom',
          [styles.verticalAlignMiddle]:
            (props.element as TTableCellElement).verticalAlign === 'middle',
        }
      )}
      {...props.attributes}
      colSpan={props.element['colspan']}
      rowSpan={props.element['rowspan']}
      onDrag={(e) => e.preventDefault()}
      data-key={props.dataKey}
    >
      {props.children}
    </td>
  )
}
